import { homeStateSelector } from "@store/redux/modules/home";
import { useSelector } from "react-redux";
import { ItemType } from "./index.d";
import RainProb from "@assets/icons/Rain_Prob.svg?react";
import { pxChangeVw } from "@/utils";
import useDayjs from "@/hooks/useDayjs";
import { useTranslation } from "react-i18next";
const { dayjs, userTimeZone } = useDayjs();
export const speakText = (text: string) => {
  if ("speechSynthesis" in window) {
    console.log(text);
    const utterance = new SpeechSynthesisUtterance(text);
    // 设置语言（可选）
    // utterance.lang = "zh-CN"; // 中文
    window.speechSynthesis.speak(utterance);
  } else {
    console.log("Speech synthesis is not supported in this browser.");
  }
};

const Hour: React.FC = () => {
  const { forecast24hour = [] } = useSelector(homeStateSelector);
  const { t: $t } = useTranslation();

  return (
    <WeatherMainContent className="content pl-0 pr-0">
      <div className="lh-25 font-bold px-16">{$t("title02")}</div>
      <div className="overflow-x-scroll overflow-y-hidden whitespace-nowrap inline-block w-full pt-10">
        {forecast24hour.map((item: ItemType, index: number) => {
          const time = userTimeZone ? dayjs.unix(item.EpochDateTime).tz(userTimeZone).format("HH:mm") : item?.Hour;
          const ariaLabel = `${$t("title02")} at ${time}: ${item?.Temperature?.Value}${item?.Temperature?.Unit}, ${
            item?.Wind?.Value
          }${item?.Wind?.Unit}, Precipitation Probability ${item?.PrecipitationProbability}%`;
          return (
            <div
              key={index}
              className="inline-block text-center p-[10px_5px] min-w-50 align-top"
              role="button"
              tabIndex={0}
              aria-label={ariaLabel}
              onClick={() => speakText(ariaLabel)}
              onKeyDown={e => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  speakText(ariaLabel);
                }
              }}
            >
              <div>
                <h3>
                  {item?.Temperature?.Value}
                  {item?.Temperature?.Unit}
                </h3>
              </div>
              <div className="inline-block h-30">
                <WeatherImage className="h-30 block" src={item?.WeatherIconImg} />
              </div>
              <div>
                {item?.Wind?.Value} {item?.Wind?.Unit}
              </div>
              {/* <div>
                <span className="inline-block w-40 h-20 lh-20 text-10 bg-[#000] rounded-5">H</span>
              </div> */}
              <div className="text-12 center gap-x-2">
                <RainProb style={{ width: pxChangeVw("8px") }} />
                <span>{item?.PrecipitationProbability}%</span>
              </div>
              <div className="text-12" style={{ color: index === 0 ? "#fff" : "rgba(255,255,255, 0.8)" }}>
                {/* {index === 0 ? $t('title23') : item?.Hour} */}
                {index === 0 ? $t("title23") : time}
              </div>
            </div>
          );
        })}
      </div>
    </WeatherMainContent>
  );
};
export default Hour;
